import { TALKDESK_LOGO } from '../../constants/images'
import Image from '@talkdesk/cobalt-react-image'
import Flex from '@talkdesk/cobalt-react-flex'
import { Text } from '@talkdesk/cobalt-react-typography'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import { useTranslation } from 'react-i18next'

const LoginHeader = (props) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const {
    localLoginEnabled,
    brandingSettings: {
      branding: { assets, name },
    },
  } = props

  return (
    <Flex direction='column' alignX='center' gap={4} paddingBottom={6}>
      {assets && (
        <Image
          src={TALKDESK_LOGO(assets)}
          alt={t('common.logoAlt', { name })}
          height={32}
          width={160}
        />
      )}
      <Text color={theme.gray600}>
        {localLoginEnabled
          ? t('login.credentialsSubtitle')
          : t('login.identityProviderSubtitle')}
      </Text>
    </Flex>
  )
}

export default LoginHeader
